import { useState } from 'react';

import { FiChevronUp } from 'react-icons/fi';

import NextLink from 'next/link';

import { ILayoutFilter } from '@pra-vendas-themes/interfaces/ILayoutFilter';
import { Collapse } from '@pra-vendas-themes/default/components/Collapse';

import { WithChildren } from 'types/WithChildren';

import {
  Wrapper,
  WrapperFilter,
  WrapperContent,
  WrapperOptions,
  SectionFilter,
  HeaderSection,
  Title,
  Option,
} from './styles';

const LayoutFilter: WithChildren<ILayoutFilter> = ({ children, filters }) => {
  const [filtersHidden, setFiltersHidden] = useState<string[]>();

  const handleHiddenFilter = (title: string): void => {
    if (filtersHidden?.find((filter) => filter === title)) {
      setFiltersHidden((prev) => [
        ...(prev?.filter((prevTitle) => prevTitle !== title) || []),
      ]);
    } else {
      setFiltersHidden((prev) => [...(prev || []), title]);
    }
  };

  return (
    <Wrapper>
      {!!filters.length && (
        <WrapperFilter>
          {filters?.map((filter) => {
            const itemsLength = filter?.items?.length || 0;
            if (!itemsLength) return null;

            const isHidden = filtersHidden?.find((f) => f === filter.title);

            return (
              <SectionFilter key={filter.title}>
                <HeaderSection
                  isItemsVisible={!isHidden}
                  onClick={() => handleHiddenFilter(filter.title)}
                >
                  <Title>{filter.title}</Title>
                  <FiChevronUp />
                </HeaderSection>
                <Collapse isOpen={!isHidden}>
                  <WrapperOptions>
                    {filter?.items?.map((item) =>
                      item.onClick ? (
                        <Option as="label" key={item.title}>
                          <input
                            type="checkbox"
                            checked={item.isSelected}
                            onChange={() => item.onClick?.()}
                          />
                          <span>{item.title}</span>
                        </Option>
                      ) : (
                        <NextLink key={item.title} href={item.href || '#'}>
                          <Option>- {item.title}</Option>
                        </NextLink>
                      )
                    )}
                  </WrapperOptions>
                </Collapse>
              </SectionFilter>
            );
          })}
        </WrapperFilter>
      )}
      <WrapperContent>{children}</WrapperContent>
    </Wrapper>
  );
};

export default LayoutFilter;
